import LegalPageLayout from './LegalPageLayout'
import { LegalLink } from './LegalProse'

// Shortened per instruction — the known-issues list, still-being-tested
// list, enforcement section and the source draft's internal drafting notes
// are all removed. Keeps exactly three things: the commitment, the WCAG aim
// with an honest note that testing is ongoing, and a route to report
// problems. Copy supplied directly, not derived from the longer version in
// content/unimo-accessibility-statement-draft.md — that source file has been
// shortened to match, see docs/build-log.md.
export function AccessibilityStatementPage() {
    return (
        <LegalPageLayout
            title="unimo Accessibility Statement"
            effectiveDate="21 September 2026"
            lastUpdated="21 September 2026"
        >
            <div className="space-y-4 font-light leading-relaxed text-unimo-slate">
                <p>
                    We want getunimo.com to be usable by as many people as possible, including people using screen
                    readers, screen magnification, speech recognition or keyboard-only navigation.
                </p>
                <p>
                    We&rsquo;re aiming to meet the Web Content Accessibility Guidelines (WCAG) 2.1 Level AA. The site is
                    newly rebuilt and we&rsquo;re still testing against that standard, so we&rsquo;re not claiming full
                    compliance yet.
                </p>
                <p>
                    If you find any part of this site difficult to access or use, please{' '}
                    <LegalLink href="/contact">get in touch</LegalLink> and we&rsquo;ll fix it.
                </p>
            </div>
        </LegalPageLayout>
    )
}

export default AccessibilityStatementPage
